<script lang="ts">
  import { page } from '$app/stores';
  import CheckboxButton from '$components/ui/checkbox-button.svelte';
  import { SHOP_SUBCATEGORY_FILTER_ID } from '$lib/constants';
  import { cn } from '$lib/utils';
  import { getUUID } from '$lib/utils/uuid';
  import { sub_categories } from '$lib/subcategories-i18n';
  import type { SubcategoryTranslationKey } from '$lib/subcategories-i18n/types';

  let className: string | undefined = undefined;
  export { className as class };
  export let items: (number | string)[] | undefined = undefined;

  $: translatedItems = items?.map((item) => $sub_categories(item as SubcategoryTranslationKey));
</script>

{#if items && translatedItems}
  <div
    class={cn(
      'flex lg:flex-wrap gap-2',
      'xl:mx-0 -mx-2 lg:-mx-8 hide-scrollbar overflow-x-auto px-2 lg:px-8 xl:px-0',
      className
    )}
  >
    {#each items as item, index}
      {@const id = getUUID()}
      <CheckboxButton
        class="whitespace-nowrap"
        {id}
        form="filters"
        name={SHOP_SUBCATEGORY_FILTER_ID}
        label={translatedItems[index]}
        value={item}
        checked={$page.url.searchParams.get(SHOP_SUBCATEGORY_FILTER_ID) === item}
      />
    {/each}
  </div>
{/if}
